exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3v2Jpfelf2BQwv2rwSQ9H4 {\n  display: inline-block;\n}\n\n._1yZJUMpXRbrtQjcJlQmDM7 {\n  height: 2em;\n  width: 96px;\n  box-sizing: border-box;\n  border: none;\n  text-align: center;\n  font-weight: bold;\n  margin-right: 16px;\n  vertical-align: middle;\n}\n\n._2S-_LOJWPdwwh1bZgSffh0 {\n  font-weight: lighter;\n  font-size: 0.8em;\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"offsetContainer": "_3v2Jpfelf2BQwv2rwSQ9H4",
	"inputBox": "_1yZJUMpXRbrtQjcJlQmDM7",
	"button": "_2S-_LOJWPdwwh1bZgSffh0"
};